<app-icon [class.active]="expanded" (mouseenter)="expand(true)" (mouseleave)="expand(false)">help_outline</app-icon>
<ng-container *ngIf="expanded">
	<section #section (appClickOutside)="expand(false);">
		<div *ngIf="!tooltipTemplateRef">{{ text }}</div>
		<div *ngIf="tooltipTemplateRef" [ngTemplateOutlet]="tooltipTemplateRef"></div>
	</section>
</ng-container>

